import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Users } from 'src/app/models/users';

@Component({
  selector: 'app-list-weekly-sells-reports',
  templateUrl: './list-weekly-sells-reports.component.html',
  styleUrls: ['./list-weekly-sells-reports.component.scss']
})
export class ListWeeklySellsReportsComponent implements OnInit {
  breadcrumbs: any = [];
  reportForm: any = FormGroup;
  offices: any = [];
  flagErrors: boolean = false;
  submitted: boolean = false;
  message: string = '';
  packages: any = [];
  filterPackages: any = [];
  users: Users[] = [];
  paymentsSessions: any = [];
  paymentsSessionsAppt: any = [];
  sells: any = [];
  employeesInfo: any = [];
  customPackages: any = [];
  nameEmployeeSelected: string = '';
  @ViewChild('detailsInfo', { static: false }) detailsInfo!: TemplateRef<any>;
  modalDetailsInfo: any;

  constructor (private form: FormBuilder,
               private api: ApiService,
               private modal: NgbModal) {}

  ngOnInit(): void { 
    this.breadcrumbs = [
      {
        name: 'Agenda',
        path: '/dashboard/new-calendar',
        link: true,
      },
      {
        name: 'Reportes',
        link: false,
      },
    ];

    this.validation();
    this.getOffices();
  }

  validation(): void {
    this.reportForm = this.form.group({
      officeId: ['', [Validators.required]],
      startDate: ['', [Validators.required]],
      endDate: [''],
    });
  }

  getOffices(): void {
    this.api.get('offices').subscribe({
      next: (data) => {
        this.offices = data.offices;
      },
      error: (err) => {},
    });
  }

  getUsersPerOffice(officeId: number): void {
    this.api.get(`v1/employees/office/${officeId}`).subscribe({
      next: data => {
        this.users = data.employees;
      },
      error: err => {}
    });
  }

  get f() {
    return this.reportForm.controls;
  }

  getReportInformation(): void {
    this.submitted = true;
    this.flagErrors = false;
    let endDate;

    if (this.reportForm.value.officeId == '' || !this.reportForm.value.startDate) {
      this.flagErrors = true;
      this.submitted = false;
      this.message =
        'Error, por favor verifique que hayas seleccionado al menos una "Sucursal" y la "Fecha de Inicio".';

      return;
    }

    const officeId = this.reportForm.value.officeId;
    const dateStart = `${this.reportForm.value.startDate.year}-${this.reportForm.value.startDate.month}-${this.reportForm.value.startDate.day}`;
    const dateEnd = this.reportForm.value.endDate
        ? `${this.reportForm.value.endDate.year}-${this.reportForm.value.endDate.month}-${this.reportForm.value.endDate.day}`
        : new Date().toISOString().split("T")[0];
    this.getUsersPerOffice(+officeId);

    const url = `weekly-reports/${officeId}/${dateStart}/${dateEnd}`;
    this.api.get(url).subscribe({
      next: (data) => {
        this.packages = data.packages;
        console.log(this.packages);
        this.filterPackages = this.packages;
        this.paymentsSessions = data.payments_sessions;
        this.paymentsSessionsAppt = data.payments_sessions_no_apt;
        this.sells = data.total;
        this.employeesInfo = data.employees_info_report;
      },
      error: (err) => {},
    });
  }

  resetReportData(): void {
    this.reportForm.reset();
    this.reportForm.get('officeId').setValue('');
    this.flagErrors = false;
    this.submitted = false;

    this.packages = [];
    this.paymentsSessions = [];
    this.paymentsSessionsAppt = [];
    this.sells = [];
    this.employeesInfo = [];

    return;
  }

  resetPackagesSearch(select: HTMLSelectElement): void {
    this.filterPackages = this.packages;
    select.value = '';
  }

  filterPerUser(select: HTMLSelectElement): void {
    const tempFilter = this.packages;
    this.filterPackages = tempFilter.filter((data: any) => Number(select.value) === data.employee.id);
  }

  close(): void {
    this.modalDetailsInfo.close();
  }

  openDetailsModal(dataEmployees: any, name: string): void {
    this.customPackages = dataEmployees;
    this.nameEmployeeSelected = name;

    this.modalDetailsInfo = this.modal.open(this.detailsInfo, { size: 'xl' });
  }
}
